import { Folder } from '../types';
import { apiClient } from './api';

interface CreateFolderRequest {
  name: string;
}

interface UpdateFolderRequest {
  name: string;
}

interface FoldersResponse {
  data: Folder[];
}

interface FolderResponse {
  data: Folder;
}

class FoldersService {
  private baseUrl = '/folders';

  async getFolders(): Promise<Folder[]> {
    const response = await apiClient.get<FoldersResponse>(this.baseUrl);
    return response.data.data;
  }

  async createFolder(data: CreateFolderRequest): Promise<Folder> {
    const response = await apiClient.post<FolderResponse>(this.baseUrl, {
      folder: data,
    });
    return response.data.data;
  }

  async updateFolder(id: string, data: UpdateFolderRequest): Promise<Folder> {
    const response = await apiClient.put<FolderResponse>(
      `${this.baseUrl}/${id}`,
      { folder: data }
    );
    return response.data.data;
  }

  async deleteFolder(id: string): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }
}

export const foldersService = new FoldersService();
